// -----------------------------------------------------------------------------
export enum PromotionType {
  Offer = 'offer',
  Shoutout = 'shoutout',
}

// -----------------------------------------------------------------------------
export interface RawPromotion {
  id: string;
  recommend_weight: number;
  display_limit: number;
  name: string;
  type: PromotionType;
  geo_restriction: string[];
}
